import React from 'react'
import Head from 'next/head'

import {BrandThemeName} from '@vio/core/src/brand/types'

import {getFontFaces, getTypographyCssVariables} from '../FontsLoader'

interface PropsType {
  languageCode: string
  theme: BrandThemeName
}

const FontsLoaderNext = ({languageCode, theme}: PropsType) => {
  return (
    <Head>
      <style
        id="vio-fonts-loader"
        dangerouslySetInnerHTML={{
          __html: `${getFontFaces(languageCode, theme)}\n${getTypographyCssVariables(languageCode, theme)}`
        }}
      />
    </Head>
  )
}

export default FontsLoaderNext
